<template>
  <div>
    <div class="page-top">
      <span class="back" @click="$router.back()">返回</span>
    </div>

    <div v-loading="loading" class="course-wrap">
      <el-empty
        v-if="!loading && list.length === 0"
        :description="hasId ? '暂无课程' : '请从培训列表选择课程'"
      ></el-empty>

      <el-card
        v-for="c in list"
        :key="c.id"
        class="course-card"
        shadow="hover"
        @click.native="goVideo(c)"
      >
        <div class="course-main">
          <img v-if="c.kj_img" :src="resolveMediaUrl(c.kj_img)" class="course-img" />
          <div v-else class="course-img placeholder">暂无封面</div>
          <div class="course-info">
            <div class="course-title">{{ c.kj_title }}</div>
            <div class="course-meta">
              <span>时长：{{ formatDuration(c.kj_time) }}</span>
              <el-tag
                v-if="c.type"
                size="mini"
                :type="c.type === '已完成' ? 'success' : 'info'"
              >{{ c.type }}</el-tag>
            </div>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import { getCourseList } from '../api'
import { resolveMediaUrl, formatDuration } from '../utils/media'

export default {
  name: 'CourseCatalog',
  data() {
    return {
      loading: false,
      list: [],
      hasId: false
    }
  },
  created() {
    this.hasId = !!this.$route.query.id
    if (this.hasId) {
      this.fetchList()
    }
  },
  methods: {
    resolveMediaUrl,
    formatDuration,
    async fetchList() {
      this.loading = true
      try {
        const res = await getCourseList(this.$route.query.id)
        this.list = (res && Array.isArray(res.qy)) ? res.qy : []
      } catch (e) {
        this.$message.error('获取课程目录失败')
      } finally {
        this.loading = false
      }
    },
    goVideo(c) {
      this.$router.push({
        path: '/video',
        query: {
          listId: this.$route.query.id,
          videoId: c.id,
          title: c.kj_title
        }
      })
    }
  }
}
</script>

<style scoped>
.page-top {
  max-width: 100%;
  margin: 0 auto 12px;
}

.course-wrap {
  max-width: 100%;
  margin: 0 auto;
}

.course-card {
  margin-bottom: 12px;
  cursor: pointer;
}

.course-main {
  display: flex;
  align-items: center;
}

.course-img {
  width: 120px;
  height: 72px;
  border-radius: 4px;
  object-fit: cover;
  background: #eef1f6;
  flex-shrink: 0;
}

.course-img.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  font-size: 12px;
}

.course-info {
  margin-left: 14px;
  flex: 1;
  min-width: 0;
}

.course-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.course-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 13px;
  color: #909399;
}
</style>
